import { FormEvent, useState } from 'react';
import { isPushConfigured, sendPushNotification } from '../../../lib/pushNotifications';

export default function NotificationsPanel() {
  const [title, setTitle] = useState('المهندس');
  const [body, setBody] = useState('تم إضافة تحديث جديد للموقع');
  const [url, setUrl] = useState('/');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  async function send(event: FormEvent) {
    event.preventDefault();
    if (!title.trim() || !body.trim()) return;
    setSending(true);
    setMessage('');
    try {
      const result = await sendPushNotification({ title: title.trim(), body: body.trim(), url: url.trim() || '/' });
      setMessage(`تم إرسال الإشعار ✅${result?.sent ? ` إلى ${result.sent} جهاز` : ''}`);
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'تعذر إرسال الإشعار.');
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="grid lg:grid-cols-[1fr_360px] gap-6">
      <section className="rounded-3xl border border-white/10 bg-white/5 p-5 sm:p-6">
        <h2 className="font-bold text-xl">إرسال إشعار</h2>
        <p className="text-sm text-gray-400 mt-1 mb-6">هذا القسم مجهز لإشعارات Push، يعني توصل للمستخدم حتى إذا الموقع مو مفتوح، بعد ما يوافق عليها.</p>
        <form onSubmit={send} className="space-y-4">
          <div><label className="text-sm text-gray-300 block mb-2">عنوان الإشعار</label><input value={title} onChange={(e) => setTitle(e.target.value)} className="admin-input" maxLength={80} /></div>
          <div><label className="text-sm text-gray-300 block mb-2">نص الإشعار</label><textarea value={body} onChange={(e) => setBody(e.target.value)} className="admin-input min-h-28" maxLength={240} /></div>
          <div><label className="text-sm text-gray-300 block mb-2">الصفحة اللي تنفتح عند الضغط</label><input value={url} onChange={(e) => setUrl(e.target.value)} className="admin-input" placeholder="/ أو /calculations" dir="ltr" /></div>
          {message && <div className="rounded-2xl bg-[#F5A623]/10 border border-[#F5A623]/20 p-4 text-sm text-[#F5A623]">{message}</div>}
          <button disabled={sending || !isPushConfigured} className="rounded-xl bg-[#F5A623] text-black font-bold px-6 py-3 disabled:opacity-40">{sending ? 'جاري الإرسال...' : 'إرسال الإشعار'}</button>
        </form>
      </section>

      <aside className="rounded-3xl border border-white/10 bg-white/5 p-5 h-fit">
        <h3 className="font-bold">حالة الإشعارات</h3>
        <div className={`mt-4 rounded-2xl px-4 py-3 text-sm ${isPushConfigured ? 'bg-green-500/10 text-green-300' : 'bg-yellow-500/10 text-yellow-200'}`}>{isPushConfigured ? 'واجهة الاشتراك مجهزة. إذا Edge Function مفعلة تقدر ترسل.' : 'الواجهة موجودة، لكن الإرسال بالخلفية يحتاج تفعيل VAPID و Edge Function مرة واحدة.'}</div>
        <p className="text-xs text-gray-400 leading-6 mt-4">داخل الملف موجود مجلد <span dir="ltr">supabase/functions/send-push</span> وملف تعليمات. ما راح نخزن أسماء أو أرقام؛ فقط اشتراك المتصفح اللي وافق على الإشعارات.</p>
      </aside>
    </div>
  );
}
